webpackJsonp([168179225184413],{

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n        width: 60px;\n        height: 60px;\n    '], ['\n        width: 60px;\n        height: 60px;\n    ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactBodymovin = __webpack_require__(68);
	
	var _reactBodymovin2 = _interopRequireDefault(_reactBodymovin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var unfavoritingAnimation = {
	    v: '5.1.1',
	    fr: 29.9700012207031,
	    ip: 0,
	    op: 66.0000026882351,
	    w: 50,
	    h: 50,
	    nm: 'Paint-Icon-AE',
	    ddd: 0,
	    assets: [],
	    layers: [{
	        ddd: 0,
	        ind: 1,
	        ty: 4,
	        nm: 'paint Outlines',
	        sr: 1,
	        ks: {
	            o: {
	                a: 0,
	                k: 100,
	                ix: 11
	            },
	            r: {
	                a: 0,
	                k: 0,
	                ix: 10
	            },
	            p: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 2
	            },
	            a: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 1
	            },
	            s: {
	                a: 0,
	                k: [100, 100, 100],
	                ix: 6
	            }
	        },
	        ao: 0,
	        shapes: [{
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 1,
	                    k: [{
	                        i: {
	                            x: 0.3,
	                            y: 1
	                        },
	                        o: {
	                            x: 0.167,
	                            y: 0.167
	                        },
	                        n: '0p3_1_0p167_0p167',
	                        t: 2,
	                        s: [{
	                            i: [[0, 0], [0, 0], [0, -0.58], [0, 0], [0.581, 0], [0, 0.581], [0, 0], [0.58, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -0.716], [0, 0], [-0.715, 0], [-0.005, 0.712], [0, 0], [-0.502, 0], [0, -0.501], [0, 0], [-0.907, 0], [0, 0.906], [0, 0], [-0.503, 0], [0, 0]],
	                            o: [[0, 0], [-0.581, 0], [0, 0], [0, 0.581], [-0.58, 0], [0, 0], [0, -0.58], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.715, 0], [0, 0], [0, 0.715], [0.713, 0], [0, 0], [0, -0.501], [0.503, 0], [0, 0], [0, 0.906], [0.906, 0], [0, 0], [0, -0.502], [0, 0], [0, 0]],
	                            v: [[8.699, -7.877], [4.158, -7.877], [3.107, -6.826], [3.107, -6.541], [2.055, -5.489], [1.003, -6.541], [1.003, -6.826], [-0.048, -7.877], [-8.699, -7.877], [-8.699, -2.138], [-5.238, -2.138], [-4.271, -3.814], [-3.303, -2.138], [-1.973, -2.138], [-0.678, -0.843], [-0.678, 0.292], [0.617, 1.587], [1.913, 0.3], [1.924, -1.419], [2.833, -2.328], [3.743, -1.419], [3.729, 2.705], [5.371, 4.346], [7.012, 2.705], [7.027, -1.229], [7.936, -2.138], [8.699, -2.138]],
	                            c: true
	                        }],
	                        e: [{
	                            i: [[0, 0], [0, 0], [0, -0.58], [0, 0], [0.581, 0], [0, 0.581], [0, 0], [0.58, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -0.716], [0, 0], [-0.715, 0], [-0.005, 0.712], [0, 0], [-0.502, 0], [0, -0.501], [0, 0], [-0.907, 0], [0, 0.906], [0, 0], [-0.503, 0], [0, 0]],
	                            o: [[0, 0], [-0.581, 0], [0, 0], [0, 0.581], [-0.58, 0], [0, 0], [0, -0.58], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.715, 0], [0, 0], [0, 0.715], [0.713, 0], [0, 0], [0, -0.501], [0.503, 0], [0, 0], [0, 0.906], [0.906, 0], [0, 0], [0, -0.502], [0, 0], [0, 0]],
	                            v: [[8.699, -7.877], [4.158, -7.877], [3.107, -6.826], [3.107, -6.541], [2.055, -5.489], [1.003, -6.541], [1.003, -6.826], [-0.048, -7.877], [-8.699, -7.877], [-8.699, -2.138], [-5.238, -2.138], [-4.271, -3.814], [-3.303, -2.138], [-1.973, -2.138], [-0.678, -0.843], [-0.678, 0.292], [0.617, 1.587], [1.913, 0.3], [1.924, -1.419], [2.833, -2.328], [3.743, -1.419], [3.742, 6.674], [5.384, 8.314], [7.025, 6.674], [7.027, -1.229], [7.936, -2.138], [8.699, -2.138]],
	                            c: true
	                        }]
	                    }, {
	                        i: {
	                            x: 0.3,
	                            y: 1
	                        },
	                        o: {
	                            x: 0.167,
	                            y: 0
	                        },
	                        n: '0p3_1_0p167_0',
	                        t: 21,
	                        s: [{
	                            i: [[0, 0], [0, 0], [0, -0.58], [0, 0], [0.581, 0], [0, 0.581], [0, 0], [0.58, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -0.716], [0, 0], [-0.715, 0], [-0.005, 0.712], [0, 0], [-0.502, 0], [0, -0.501], [0, 0], [-0.907, 0], [0, 0.906], [0, 0], [-0.503, 0], [0, 0]],
	                            o: [[0, 0], [-0.581, 0], [0, 0], [0, 0.581], [-0.58, 0], [0, 0], [0, -0.58], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.715, 0], [0, 0], [0, 0.715], [0.713, 0], [0, 0], [0, -0.501], [0.503, 0], [0, 0], [0, 0.906], [0.906, 0], [0, 0], [0, -0.502], [0, 0], [0, 0]],
	                            v: [[8.699, -7.877], [4.158, -7.877], [3.107, -6.826], [3.107, -6.541], [2.055, -5.489], [1.003, -6.541], [1.003, -6.826], [-0.048, -7.877], [-8.699, -7.877], [-8.699, -2.138], [-5.238, -2.138], [-4.271, -3.814], [-3.303, -2.138], [-1.973, -2.138], [-0.678, -0.843], [-0.678, 0.292], [0.617, 1.587], [1.913, 0.3], [1.924, -1.419], [2.833, -2.328], [3.743, -1.419], [3.742, 6.674], [5.384, 8.314], [7.025, 6.674], [7.027, -1.229], [7.936, -2.138], [8.699, -2.138]],
	                            c: true
	                        }],
	                        e: [{
	                            i: [[0, 0], [0, 0], [0, -0.58], [0, 0], [0.581, 0], [0, 0.581], [0, 0], [0.58, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -0.716], [0, 0], [-0.715, 0], [-0.005, 0.712], [0, 0], [-0.502, 0], [0, -0.501], [0, 0], [-0.907, 0], [0, 0.906], [0, 0], [-0.503, 0], [0, 0]],
	                            o: [[0, 0], [-0.581, 0], [0, 0], [0, 0.581], [-0.58, 0], [0, 0], [0, -0.58], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.715, 0], [0, 0], [0, 0.715], [0.713, 0], [0, 0], [0, -0.501], [0.503, 0], [0, 0], [0, 0.906], [0.906, 0], [0, 0], [0, -0.502], [0, 0], [0, 0]],
	                            v: [[8.699, -7.877], [4.158, -7.877], [3.107, -6.826], [3.107, -6.541], [2.055, -5.489], [1.003, -6.541], [1.003, -6.826], [-0.048, -7.877], [-8.699, -7.877], [-8.699, -2.138], [-5.238, -2.138], [-4.271, -3.814], [-3.303, -2.138], [-1.973, -2.138], [-0.678, -0.843], [-0.678, 0.292], [0.617, 1.587], [1.913, 0.3], [1.924, -1.419], [2.833, -2.328], [3.743, -1.419], [3.742, 6.674], [5.384, 8.314], [7.025, 6.674], [7.027, -1.229], [7.936, -2.138], [8.699, -2.138]],
	                            c: true
	                        }]
	                    }, {
	                        i: {
	                            x: 0.667,
	                            y: 1
	                        },
	                        o: {
	                            x: 0.167,
	                            y: 0
	                        },
	                        n: '0p667_1_0p167_0',
	                        t: 27,
	                        s: [{
	                            i: [[0, 0], [0, 0], [0, -0.58], [0, 0], [0.581, 0], [0, 0.581], [0, 0], [0.58, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -0.716], [0, 0], [-0.715, 0], [-0.005, 0.712], [0, 0], [-0.502, 0], [0, -0.501], [0, 0], [-0.907, 0], [0, 0.906], [0, 0], [-0.503, 0], [0, 0]],
	                            o: [[0, 0], [-0.581, 0], [0, 0], [0, 0.581], [-0.58, 0], [0, 0], [0, -0.58], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.715, 0], [0, 0], [0, 0.715], [0.713, 0], [0, 0], [0, -0.501], [0.503, 0], [0, 0], [0, 0.906], [0.906, 0], [0, 0], [0, -0.502], [0, 0], [0, 0]],
	                            v: [[8.699, -7.877], [4.158, -7.877], [3.107, -6.826], [3.107, -6.541], [2.055, -5.489], [1.003, -6.541], [1.003, -6.826], [-0.048, -7.877], [-8.699, -7.877], [-8.699, -2.138], [-5.238, -2.138], [-4.271, -3.814], [-3.303, -2.138], [-1.973, -2.138], [-0.678, -0.843], [-0.678, 0.292], [0.617, 1.587], [1.913, 0.3], [1.924, -1.419], [2.833, -2.328], [3.743, -1.419], [3.742, 6.674], [5.384, 8.314], [7.025, 6.674], [7.027, -1.229], [7.936, -2.138], [8.699, -2.138]],
	                            c: true
	                        }],
	                        e: [{
	                            i: [[0, 0], [0, 0], [0, -0.58], [0, 0], [0.581, 0], [0, 0.581], [0, 0], [0.58, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -0.716], [0, 0], [-0.715, 0], [-0.005, 0.712], [0, 0], [-0.502, 0], [0, -0.501], [0, 0], [-0.907, 0], [0, 0.906], [0, 0], [-0.503, 0], [0, 0]],
	                            o: [[0, 0], [-0.581, 0], [0, 0], [0, 0.581], [-0.58, 0], [0, 0], [0, -0.58], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.715, 0], [0, 0], [0, 0.715], [0.713, 0], [0, 0], [0, -0.501], [0.503, 0], [0, 0], [0, 0.906], [0.906, 0], [0, 0], [0, -0.502], [0, 0], [0, 0]],
	                            v: [[8.699, -7.877], [4.158, -7.877], [3.107, -6.826], [3.107, -6.541], [2.055, -5.489], [1.003, -6.541], [1.003, -6.826], [-0.048, -7.877], [-8.699, -7.877], [-8.699, -2.138], [-5.238, -2.138], [-4.271, -3.814], [-3.303, -2.138], [-1.973, -2.138], [-0.678, -0.843], [-0.678, 0.292], [0.617, 1.587], [1.913, 0.3], [1.924, -1.419], [2.833, -2.328], [3.743, -1.419], [3.729, 2.705], [5.371, 4.346], [7.012, 2.705], [7.027, -1.229], [7.936, -2.138], [8.699, -2.138]],
	                            c: true
	                        }]
	                    }, {
	                        t: 49.0000019958109
	                    }],
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 0.773000021542, 0.039000002543, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [13.43, 33.123],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 1',
	            np: 3,
	            cix: 2,
	            ix: 1,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }],
	        ip: 0,
	        op: 66.0000026882351,
	        st: 0,
	        bm: 0
	    }, {
	        ddd: 0,
	        ind: 2,
	        ty: 4,
	        nm: 'Paint Splotch Outlines',
	        sr: 1,
	        ks: {
	            o: {
	                a: 1,
	                k: [{
	                    i: {
	                        x: [0.833],
	                        y: [0.833]
	                    },
	                    o: {
	                        x: [0.167],
	                        y: [0.167]
	                    },
	                    n: ['0p833_0p833_0p167_0p167'],
	                    t: 20,
	                    s: [0],
	                    e: [100]
	                }, {
	                    i: {
	                        x: [0.833],
	                        y: [0.833]
	                    },
	                    o: {
	                        x: [0.167],
	                        y: [0.167]
	                    },
	                    n: ['0p833_0p833_0p167_0p167'],
	                    t: 21,
	                    s: [100],
	                    e: [100]
	                }, {
	                    i: {
	                        x: [0.833],
	                        y: [0.833]
	                    },
	                    o: {
	                        x: [0.167],
	                        y: [0.167]
	                    },
	                    n: ['0p833_0p833_0p167_0p167'],
	                    t: 34,
	                    s: [100],
	                    e: [0]
	                }, {
	                    t: 37.0000015070409
	                }],
	                ix: 11
	            },
	            r: {
	                a: 0,
	                k: 0,
	                ix: 10
	            },
	            p: {
	                a: 1,
	                k: [{
	                    i: {
	                        x: 0.667,
	                        y: 1
	                    },
	                    o: {
	                        x: 0.333,
	                        y: 0
	                    },
	                    n: '0p667_1_0p333_0',
	                    t: 18,
	                    s: [25, 25, 0],
	                    e: [25, 33, 0],
	                    to: [0, 1.33333337306976, 0],
	                    ti: [0, -1.33333337306976, 0]
	                }, {
	                    t: 34.0000013848484
	                }],
	                ix: 2
	            },
	            a: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 1
	            },
	            s: {
	                a: 0,
	                k: [100, 100, 100],
	                ix: 6
	            }
	        },
	        ao: 0,
	        shapes: [{
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, -0.897], [0.897, 0], [0, 0.897], [-0.897, 0]],
	                        o: [[0, 0.897], [-0.897, 0], [0, -0.897], [0.897, 0]],
	                        v: [[1.625, 0], [0, 1.625], [-1.625, 0], [0, -1.625]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 0.773000021542, 0.039000002543, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [18.771, 39.243],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 1',
	            np: 3,
	            cix: 2,
	            ix: 1,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }],
	        ip: 0,
	        op: 66.0000026882351,
	        st: 0,
	        bm: 0
	    }, {
	        ddd: 0,
	        ind: 5,
	        ty: 4,
	        nm: 'everything else Outlines',
	        sr: 1,
	        ks: {
	            o: {
	                a: 0,
	                k: 100,
	                ix: 11
	            },
	            r: {
	                a: 0,
	                k: 0,
	                ix: 10
	            },
	            p: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 2
	            },
	            a: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 1
	            },
	            s: {
	                a: 0,
	                k: [100, 100, 100],
	                ix: 6
	            }
	        },
	        ao: 0,
	        shapes: [{
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[4.731, 21.599], [22.13, 21.599]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 1',
	            np: 2,
	            cix: 2,
	            ix: 1,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [-3.078, 0], [1.54, 2.666]],
	                        o: [[0, 0], [-1.54, 2.666], [3.079, 0], [0, 0]],
	                        v: [[-0.001, -5.999], [-3.464, 0.001], [-0.001, 5.999], [3.464, 0.001]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 0.773000021542, 0.039000002543, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [30.776, 10.356],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 2',
	            np: 3,
	            cix: 2,
	            ix: 2,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0.446], [2.238, -0.407], [0.286, -1.361], [-0.164, -0.544], [0, -2.526], [0, 0], [0, 0], [0, 0], [-0.991, 2.559]],
	                        o: [[0, -2.163], [-1.367, 0.248], [-0.13, 0.622], [0.726, 2.419], [0, 0], [0, 0], [0, 0], [0, -2.744], [0.151, -0.392]],
	                        v: [[3.55, -3.377], [-0.637, -6.841], [-3.42, -4.136], [-3.352, -2.37], [-2.007, 5.025], [-2.007, 7.248], [2.058, 7.248], [2.058, 5.972], [3.316, -2.114]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0, 0.458999992819, 0.788000009574, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [13.405, 8.071],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 3',
	            np: 3,
	            cix: 2,
	            ix: 3,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [1.138, 0], [0, 0], [0, -1.138], [0, 0]],
	                        o: [[0, 0], [0, -1.138], [0, 0], [-1.138, 0], [0, 0], [0, 0]],
	                        v: [[8.699, 7.228], [8.699, -5.168], [6.639, -7.228], [-6.639, -7.228], [-8.699, -5.168], [-8.699, 2.698]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [13.43, 22.547],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 4',
	            np: 3,
	            cix: 2,
	            ix: 4,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0]],
	                        o: [[0, 0]],
	                        v: [[4.731, 25.246]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 5',
	            np: 2,
	            cix: 2,
	            ix: 5,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [],
	                        o: [],
	                        v: [],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [0.5, 0.5],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 6',
	            np: 2,
	            cix: 2,
	            ix: 6,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [-0.85, 0], [0, 0], [0, -0.85]],
	                        o: [[0, 0], [0, 0], [0, -0.85], [0, 0], [0.85, 0], [0, 0]],
	                        v: [[8.699, 2.561], [-8.699, 2.561], [-8.699, -1.021], [-7.161, -2.561], [7.16, -2.561], [8.699, -1.021]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [13.43, 17.88],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 7',
	            np: 3,
	            cix: 2,
	            ix: 7,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, -0.595], [0.594, 0], [0, 0.594], [-0.595, 0]],
	                        o: [[0, 0.594], [-0.595, 0], [0, -0.595], [0.594, 0]],
	                        v: [[1.076, 0.001], [0.001, 1.076], [-1.076, 0.001], [0.001, -1.076]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [42.979, 28.7],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 8',
	            np: 2,
	            cix: 2,
	            ix: 8,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, -0.595], [0.595, 0], [0, 0.594], [-0.594, 0]],
	                        o: [[0, 0.594], [-0.594, 0], [0, -0.595], [0.595, 0]],
	                        v: [[1.076, 0.001], [-0.001, 1.076], [-1.076, 0.001], [-0.001, -1.076]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [28.34, 28.7],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 9',
	            np: 2,
	            cix: 2,
	            ix: 9,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [3.991, 0], [0, 3.99], [0, 0]],
	                        o: [[0, 0], [0, 3.99], [-3.99, 0], [0, 0], [0, 0]],
	                        v: [[7.225, -6.654], [7.225, -0.572], [-0.001, 6.654], [-7.225, -0.572], [-7.225, -6.654]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [36.452, 36.131],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 10',
	            np: 2,
	            cix: 2,
	            ix: 10,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[7.632, 4.156], [-7.632, 4.156], [-7.632, -4.156], [7.632, -4.156]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0, 0.458999992819, 0.788000009574, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [34.044, 36.131],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 11',
	            np: 3,
	            cix: 2,
	            ix: 11,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0.534, 0], [0, 0], [0, 0.534], [0, 0], [-0.534, 0], [0, 0], [0, -0.535], [0, 0]],
	                        o: [[0, 0], [-0.534, 0], [0, 0], [0, -0.535], [0, 0], [0.534, 0], [0, 0], [0, 0.534]],
	                        v: [[11.8, 1.209], [-11.801, 1.209], [-12.768, 0.241], [-12.768, -0.241], [-11.801, -1.209], [11.8, -1.209], [12.768, -0.241], [12.768, 0.241]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [30.488, 22.808],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 12',
	            np: 3,
	            cix: 2,
	            ix: 12,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0.553, 0], [0, 0], [0, 0.553], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [-0.552, 0], [0, 0], [0, 0], [0, 0], [0, 0.553]],
	                        v: [[10.188, 12.117], [-10.188, 12.117], [-11.188, 11.117], [-11.188, -12.117], [11.188, -12.117], [11.188, 11.117]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [30.488, 36.133],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 13',
	            np: 3,
	            cix: 2,
	            ix: 13,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, -11.907], [11.907, 0], [0, 11.907], [-11.907, 0]],
	                        o: [[0, 11.907], [-11.907, 0], [0, -11.907], [11.907, 0]],
	                        v: [[21.559, 0], [0.001, 21.559], [-21.559, 0], [0.001, -21.559]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0.902000038297, 0.902000038297, 0.902000038297, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [25.071, 25.898],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 14',
	            np: 2,
	            cix: 2,
	            ix: 14,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }],
	        ip: 0,
	        op: 66.0000026882351,
	        st: 0,
	        bm: 0
	    }],
	    markers: []
	};
	
	
	var PaintIcon = function PaintIcon(_ref) {
	    var autoplay = _ref.autoplay;
	
	
	    var PaintIconContainer = _styledComponents2.default.div(_templateObject);
	
	    var bodymovinOptions = {
	        loop: true,
	        autoplay: { autoplay: autoplay },
	        prerender: true,
	        animationData: unfavoritingAnimation
	    };
	
	    return _react2.default.createElement(
	        PaintIconContainer,
	        null,
	        _react2.default.createElement(_reactBodymovin2.default, { options: bodymovinOptions })
	    );
	};
	
	exports.default = PaintIcon;

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _Heading = __webpack_require__(44);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Form = __webpack_require__(52);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _SubpageBodyStyles = __webpack_require__(55);
	
	var _LandingHeader = __webpack_require__(24);
	
	var _LandingHeader2 = _interopRequireDefault(_LandingHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var relativePath = ("/pages/have-it-made/");
	
	var SubpageBody = function SubpageBody(_ref) {
	    var children = _ref.children,
	        headerText = _ref.headerText,
	        subHeaderText = _ref.subHeaderText,
	        category = _ref.category,
	        formHeading = _ref.formHeading,
	        backgroundImages = _ref.backgroundImages;
	
	
	    var redirectOnSubmit = function redirectOnSubmit(state) {
	        var redirectRelativePath = headerText.toLowerCase();
	        if (state.isLeadForm) {
	            window.location.href = '' + relativePath + redirectRelativePath + '/thank-you?zip=' + state.values.zip;
	        } else {
	            window.location.href = '' + relativePath + redirectRelativePath + '/thanks';
	        }
	    };
	
	    return _react2.default.createElement(
	        _SubpageBodyStyles.SubpageBodyContainer,
	        {
	            backgroundImages: backgroundImages },
	        _react2.default.createElement(
	            'div',
	            { className: 'header-overlay' },
	            _react2.default.createElement('div', { className: 'header-overlay-filter' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'subpage-column-left' },
	            _react2.default.createElement(
	                'span',
	                { className: 'subpage-header' },
	                _react2.default.createElement(
	                    _Heading2.default,
	                    {
	                        headingSize: 'xxlarge',
	                        headingTag: 'h1',
	                        headingColor: _colors2.default.wsWhite },
	                    headerText
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'subpage-content' },
	                _react2.default.createElement(
	                    _Heading2.default,
	                    {
	                        headingSize: 'xlarge',
	                        headingTag: 'h2',
	                        headingColor: _colors2.default.grayscaleCoolGray11 },
	                    subHeaderText
	                ),
	                _react2.default.createElement(
	                    _SubpageBodyStyles.BodyCopyContainer,
	                    null,
	                    children
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'subpage-column-right' },
	            _react2.default.createElement(_Form2.default, { formTypes: { originWebApp: 'clayton-homes-website', originWebPageType: 'him-campaign-landing-page', originCampaign: 'him-2018', originWebFormCategory: category },
	                options: { formHeading: formHeading, redirect: redirectOnSubmit } })
	        )
	    );
	};
	
	exports.default = SubpageBody;
	module.exports = exports['default'];

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BodyCopyContainer = exports.SubpageBodyContainer = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\n    /* - DESKTOP VIEW - */\n    @media screen and (', '){\n        display: table;\n        max-width: 1750px;\n        padding-left: 11.2%;\n\n        .subpage-column-left {\n            display: table-cell;\n            padding-top: 170px\n        }\n\n        .subpage-column-right {\n            display: table-cell;\n            padding-left: 17px;\n            padding-top: 268px;\n            width: 483px;\n        }\n\n        .subpage-content {\n            padding-top: 35px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n        }\n        \n        .react-bodymovin-container {\n            height: 50px;\n            width: 50px;\n        }\n\n        h2 {\n            line-height: 1.14;\n            margin-bottom: 25px;\n        }\n\n        h3 {\n            font-size: 22px;\n            margin: 0;\n        }\n    }\n\n    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {  \n        .movin-header svg {\n            height: 60px !important;\n            width: 60px !important;\n        }\n    }\n\n    /* - TABLET VIEW - */\n    @media screen and (', '){\n        display: table;\n        padding-left: 5.4%;\n        width: 100%;\n\n        .subpage-column-left {\n            display: table-cell;\n            padding-top: 188px\n        }\n\n        .subpage-column-right {\n            display: table-cell;\n            padding-left: 29px;\n            padding-top: 268px;\n            width: 375px;\n        }\n\n        .subpage-content {\n            padding-top: 44px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n\n            h1 {\n                font-size: 32px;\n                letter-spacing: -.8px;\n            }\n\n            \n            h2 {\n                font-size: 30px;\n                letter-spacing: -2px;\n                line-height: 1;\n                margin-left: -5px;\n                margin-bottom: 25px;\n            }\n\n            h3 {\n                font-size: 22px;\n                margin: 0;\n            }\n        }\n        \n        .react-bodymovin-container {\n            height: 60px;\n            width: 60px;\n        }\n\n    }\n\n    /* - MOBILE VIEW - */\n    @media screen and (', '){\n        display: block;\n        padding-left: 15px;\n        width: 100%;\n\n        .subpage-column-left {\n            display: block;\n            padding-top: 202px\n        }\n\n        .subpage-column-right {\n            display: block;\n            padding-left: 0;\n            padding-right: 18px;\n            padding-top: 20px;\n            width: 100%;\n        }\n\n        .subpage-content {\n            padding-top: 30px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n\n            h1 {\n                font-size: 33px;\n                letter-spacing: -.9px;\n            }\n\n            h2 {\n                font-size: 27px;\n                letter-spacing: -.5px;\n                line-height: 1.1;\n                margin-left: 0px;\n                margin-bottom: 25px;\n            }\n\n            h3 {\n                font-size: 22px;\n                margin: 0;\n            }\n        }\n        \n        .react-bodymovin-container {\n            height: 65px;\n            width: 65px;\n        }\n\n    }\n'], ['\n\n    /* - DESKTOP VIEW - */\n    @media screen and (', '){\n        display: table;\n        max-width: 1750px;\n        padding-left: 11.2%;\n\n        .subpage-column-left {\n            display: table-cell;\n            padding-top: 170px\n        }\n\n        .subpage-column-right {\n            display: table-cell;\n            padding-left: 17px;\n            padding-top: 268px;\n            width: 483px;\n        }\n\n        .subpage-content {\n            padding-top: 35px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n        }\n        \n        .react-bodymovin-container {\n            height: 50px;\n            width: 50px;\n        }\n\n        h2 {\n            line-height: 1.14;\n            margin-bottom: 25px;\n        }\n\n        h3 {\n            font-size: 22px;\n            margin: 0;\n        }\n    }\n\n    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {  \n        .movin-header svg {\n            height: 60px !important;\n            width: 60px !important;\n        }\n    }\n\n    /* - TABLET VIEW - */\n    @media screen and (', '){\n        display: table;\n        padding-left: 5.4%;\n        width: 100%;\n\n        .subpage-column-left {\n            display: table-cell;\n            padding-top: 188px\n        }\n\n        .subpage-column-right {\n            display: table-cell;\n            padding-left: 29px;\n            padding-top: 268px;\n            width: 375px;\n        }\n\n        .subpage-content {\n            padding-top: 44px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n\n            h1 {\n                font-size: 32px;\n                letter-spacing: -.8px;\n            }\n\n            \n            h2 {\n                font-size: 30px;\n                letter-spacing: -2px;\n                line-height: 1;\n                margin-left: -5px;\n                margin-bottom: 25px;\n            }\n\n            h3 {\n                font-size: 22px;\n                margin: 0;\n            }\n        }\n        \n        .react-bodymovin-container {\n            height: 60px;\n            width: 60px;\n        }\n\n    }\n\n    /* - MOBILE VIEW - */\n    @media screen and (', '){\n        display: block;\n        padding-left: 15px;\n        width: 100%;\n\n        .subpage-column-left {\n            display: block;\n            padding-top: 202px\n        }\n\n        .subpage-column-right {\n            display: block;\n            padding-left: 0;\n            padding-right: 18px;\n            padding-top: 20px;\n            width: 100%;\n        }\n\n        .subpage-content {\n            padding-top: 30px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n\n            h1 {\n                font-size: 33px;\n                letter-spacing: -.9px;\n            }\n\n            h2 {\n                font-size: 27px;\n                letter-spacing: -.5px;\n                line-height: 1.1;\n                margin-left: 0px;\n                margin-bottom: 25px;\n            }\n\n            h3 {\n                font-size: 22px;\n                margin: 0;\n            }\n        }\n        \n        .react-bodymovin-container {\n            height: 65px;\n            width: 65px;\n        }\n\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    color: ', ';\n    font-family: "source-sans-pro", sans-serif;\n    font-size: 16px;\n    line-height: 27px;\n'], ['\n    color: ', ';\n    font-family: "source-sans-pro", sans-serif;\n    font-size: 16px;\n    line-height: 27px;\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _LandingPageStyles = __webpack_require__(11);
	
	var _LandingPageStyles2 = _interopRequireDefault(_LandingPageStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SubpageBodyContainer = exports.SubpageBodyContainer = _styledComponents2.default.div(_templateObject, _LandingPageStyles2.default.viewBreakpoints.desktop, _LandingPageStyles2.default.viewBreakpoints.tablet, _LandingPageStyles2.default.viewBreakpoints.mobile);
	
	var BodyCopyContainer = exports.BodyCopyContainer = _styledComponents2.default.div(_templateObject2, _colors2.default.grayscaleCoolGray08);

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(42);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _CircleArrow = __webpack_require__(76);
	
	var _CircleArrow2 = _interopRequireDefault(_CircleArrow);
	
	var _SubpageFooterStyles = __webpack_require__(57);
	
	var _LandingFooter = __webpack_require__(53);
	
	var _LandingFooter2 = _interopRequireDefault(_LandingFooter);
	
	var _urlTools = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubpageFooter = function SubpageFooter(_ref) {
	    var linkNext = _ref.linkNext,
	        linkPrev = _ref.linkPrev,
	        textNext = _ref.textNext,
	        textPrev = _ref.textPrev;
	
	    return _react2.default.createElement(
	        _SubpageFooterStyles.SubpageFooterContainer,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'footer-nav' },
	            _react2.default.createElement(
	                'div',
	                { className: 'footer-left' },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: (0, _urlTools.getLinkWithQueryString)(linkPrev) },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'standard-state' },
	                        _react2.default.createElement(_CircleArrow2.default, { circleColor: _colors2.default.secondaryRubberDucky, arrowColor: _colors2.default.grayscaleCoolGray11, backgroundColor: 'rgba(255, 197, 10, 1)', circleDiameter: '33' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hover-state' },
	                        _react2.default.createElement(_CircleArrow2.default, { circleColor: _colors2.default.secondaryRubberDucky, arrowColor: _colors2.default.grayscaleCoolGray11, backgroundColor: 'rgba(255, 197, 10, 0)', circleDiameter: '33' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'nav-text' },
	                        textPrev
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'footer-right' },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: (0, _urlTools.getLinkWithQueryString)(linkNext) },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'nav-text' },
	                        textNext
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'standard-state' },
	                        _react2.default.createElement(_CircleArrow2.default, { circleColor: _colors2.default.secondaryRubberDucky, arrowColor: _colors2.default.grayscaleCoolGray11, backgroundColor: 'rgba(255, 197, 10, 1)', circleDiameter: '33' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hover-state' },
	                        _react2.default.createElement(_CircleArrow2.default, { circleColor: _colors2.default.secondaryRubberDucky, arrowColor: _colors2.default.grayscaleCoolGray11, backgroundColor: 'rgba(255, 197, 10, 0)', circleDiameter: '33' })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_LandingFooter2.default, null)
	    );
	};
	
	exports.default = SubpageFooter;
	module.exports = exports['default'];

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SubpageFooterContainer = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    margin-top: 57px;\n\n    .footer-nav {\n        align-items: center;\n        display: flex;\n        justify-content: space-between;\n        max-width: 100%;\n    }\n    \n    .nav-text {\n        color: ', ';\n        font-family: \'acumin-pro\', sans-serif;\n        font-size: 18px;\n        font-weight: 500;\n        line-height: 1.28;\n        letter-spacing: normal;\n        position: absolute;\n        top: 32%;\n        transform: translateY(-50%);\n    }\n    .footer-left {\n        position: relative;\n        width: 50%;\n\n        .nav-text {\n            left: 45px;\n        }\n        .circle-arrow {\n            transform: rotate(180deg);\n        }\n        .hover-state {\n            display: none;\n        }\n        .standard-state {\n            display: inline;\n        }\n        svg {\n            height: 33px;\n            width: 33px;\n        }\n        a:hover {\n            .hover-state {\n                display: inline;\n            }\n            .standard-state {\n                display: none;\n            }\n        }\n    }\n    .footer-right {\n        position: relative;\n        text-align: right;\n        width: 50%;\n\n        .nav-text {\n            right: 45px;\n        }\n        .hover-state {\n            display: none;\n        }\n        .standard-state {\n            display: inline;\n        }\n        svg {\n            height: 33px;\n            width: 33px;\n        }\n        a:hover {\n            .hover-state {\n                display: inline;\n            }\n            .standard-state {\n                display: none;\n            }\n        }\n    }\n    .circle-arrow {\n        display: inline-block;\n        margin-bottom: 12px;\n        max-width: 64px;\n    }\n\n    .footer-container {\n        color: ', ';\n        position: relative;\n\n        a {\n            color: ', ';\n\n            &:hover {\n                color: ', ';\n            }\n        }\n    }\n\n    /* - DESKTOP VIEW - */\n    @media screen and (', '){\n        .footer-nav {\n            margin: 0 1.58%;\n        }\n    }\n\n    /* - TABLET VIEW - */\n    @media screen and (', '){\n        .footer-nav {\n            margin: 0 4%;\n        }\n    }\n\n    /* - MOBILE VIEW - */\n    @media screen and (', '){\n        margin-top: 0;\n\n        .footer-nav {\n            margin: auto;\n            width: 80%;\n        }\n\n        .footer-right,\n        .footer-left {\n            a:hover {\n                .hover-state {\n                    display: none;\n                }\n                .standard-state {\n                    display: inline-block;\n                }\n            }\n        }\n    }\n'], ['\n    margin-top: 57px;\n\n    .footer-nav {\n        align-items: center;\n        display: flex;\n        justify-content: space-between;\n        max-width: 100%;\n    }\n    \n    .nav-text {\n        color: ', ';\n        font-family: \'acumin-pro\', sans-serif;\n        font-size: 18px;\n        font-weight: 500;\n        line-height: 1.28;\n        letter-spacing: normal;\n        position: absolute;\n        top: 32%;\n        transform: translateY(-50%);\n    }\n    .footer-left {\n        position: relative;\n        width: 50%;\n\n        .nav-text {\n            left: 45px;\n        }\n        .circle-arrow {\n            transform: rotate(180deg);\n        }\n        .hover-state {\n            display: none;\n        }\n        .standard-state {\n            display: inline;\n        }\n        svg {\n            height: 33px;\n            width: 33px;\n        }\n        a:hover {\n            .hover-state {\n                display: inline;\n            }\n            .standard-state {\n                display: none;\n            }\n        }\n    }\n    .footer-right {\n        position: relative;\n        text-align: right;\n        width: 50%;\n\n        .nav-text {\n            right: 45px;\n        }\n        .hover-state {\n            display: none;\n        }\n        .standard-state {\n            display: inline;\n        }\n        svg {\n            height: 33px;\n            width: 33px;\n        }\n        a:hover {\n            .hover-state {\n                display: inline;\n            }\n            .standard-state {\n                display: none;\n            }\n        }\n    }\n    .circle-arrow {\n        display: inline-block;\n        margin-bottom: 12px;\n        max-width: 64px;\n    }\n\n    .footer-container {\n        color: ', ';\n        position: relative;\n\n        a {\n            color: ', ';\n\n            &:hover {\n                color: ', ';\n            }\n        }\n    }\n\n    /* - DESKTOP VIEW - */\n    @media screen and (', '){\n        .footer-nav {\n            margin: 0 1.58%;\n        }\n    }\n\n    /* - TABLET VIEW - */\n    @media screen and (', '){\n        .footer-nav {\n            margin: 0 4%;\n        }\n    }\n\n    /* - MOBILE VIEW - */\n    @media screen and (', '){\n        margin-top: 0;\n\n        .footer-nav {\n            margin: auto;\n            width: 80%;\n        }\n\n        .footer-right,\n        .footer-left {\n            a:hover {\n                .hover-state {\n                    display: none;\n                }\n                .standard-state {\n                    display: inline-block;\n                }\n            }\n        }\n    }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _LandingPageStyles = __webpack_require__(11);
	
	var _LandingPageStyles2 = _interopRequireDefault(_LandingPageStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SubpageFooterContainer = exports.SubpageFooterContainer = _styledComponents2.default.div(_templateObject, _colors2.default.grayscaleCoolGray11, _colors2.default.grayscaleCoolGray06, _colors2.default.grayscaleCoolGray06, _colors2.default.grayscaleCoolGray08, _LandingPageStyles2.default.viewBreakpoints.desktop, _LandingPageStyles2.default.viewBreakpoints.tablet, _LandingPageStyles2.default.viewBreakpoints.mobile);

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/subpages-style-header.e8e06f5d.jpg";

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/subpages-style-mobile.0b82fd26.jpg";

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/subpages-style-tablet.c9c073e0.jpg";

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PaintIcon = __webpack_require__(477);
	
	var _PaintIcon2 = _interopRequireDefault(_PaintIcon);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _LandingHeader = __webpack_require__(24);
	
	var _LandingHeader2 = _interopRequireDefault(_LandingHeader);
	
	__webpack_require__(94);
	
	var _SubpageStyles = __webpack_require__(58);
	
	var _SubpageStyles2 = _interopRequireDefault(_SubpageStyles);
	
	var _SubpageBody = __webpack_require__(54);
	
	var _SubpageBody2 = _interopRequireDefault(_SubpageBody);
	
	var _SubpageFooter = __webpack_require__(56);
	
	var _SubpageFooter2 = _interopRequireDefault(_SubpageFooter);
	
	var _Analytics = __webpack_require__(18);
	
	var _ImageSets = __webpack_require__(77);
	
	var _ImageSets2 = _interopRequireDefault(_ImageSets);
	
	var _ScriptTags = __webpack_require__(28);
	
	var _ScriptTags2 = _interopRequireDefault(_ScriptTags);
	
	var _subpagesStyleMobile = __webpack_require__(598);
	
	var _subpagesStyleMobile2 = _interopRequireDefault(_subpagesStyleMobile);
	
	var _subpagesStyleTablet = __webpack_require__(601);
	
	var _subpagesStyleTablet2 = _interopRequireDefault(_subpagesStyleTablet);
	
	var _subpagesStyleHeader = __webpack_require__(590);
	
	var _subpagesStyleHeader2 = _interopRequireDefault(_subpagesStyleHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Style = function Style() {
	
	    var backgroundImages = new _ImageSets2.default(_subpagesStyleMobile2.default, _subpagesStyleTablet2.default, _subpagesStyleHeader2.default);
	
	    return _react2.default.createElement(
	        _SubpageStyles2.default,
	        { backgroundImages: backgroundImages },
	        _react2.default.createElement(_LandingHeader2.default, null),
	        _react2.default.createElement(
	            _SubpageBody2.default,
	            {
	                category: 'style',
	                headerText: 'Style',
	                formHeading: 'From shiplap accents to added functional storage, you can customize your dream home to be everything you\'ve ever wanted.',
	                subHeaderText: 'Clayton Built\xAE Homes: Designed to Impress',
	                backgroundImages: backgroundImages },
	            _react2.default.createElement(
	                'div',
	                { className: 'movin-header' },
	                _react2.default.createElement(_PaintIcon2.default, null),
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Get the style you want at a price you\u2019ll love.'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'body-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'body-column-left' },
	                    'Whether your style is modern, contemporary, French country or farmhouse, we\u2019ve got something for you! Our architects and home designers stay up-to-date on the latest interior home design trends so we can offer you countless home features and customization options to choose from that will fit your lifestyle and your budget. '
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'body-column-right' },
	                    'From shiplap accents to added functional storage, you can customize your dream home to be everything you\u2019ve ever wanted. Sign up to get our *free* Home Buyer\u2019s Guide to learn more about the style, quality and affordability of Clayton Built\xAE homes and receive more information from Clayton!'
	                )
	            )
	        ),
	        _react2.default.createElement(_SubpageFooter2.default, {
	            linkNext: '/affordability',
	            linkPrev: '/quality',
	            textNext: 'Affordability',
	            textPrev: 'Quality'
	        }),
	        _react2.default.createElement(_ScriptTags2.default, null),
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            {
	                onChangeClientState: _Analytics.onHelmetChangeClientState,
	                script: [{
	                    type: 'text/javascript',
	                    innerHTML: '\n                        if (typeof fbq !== \'undefined\'){\n                            fbq(\'track\', \'PageView\');\n                        }\n                        if (typeof gtag !== \'undefined\'){\n                            gtag(\'event\', \'page_view\', {\'send_to\': \'AW-1040796449\',\'dynx_itemid\': \'HIM2018\',\'dynx_pagetype\': \'Style\'});\n                            gtag(\'event\', \'conversion\', {\n                                \'allow_custom_scripts\': true,\n                                \'send_to\': \'DC-6346097/fall1003/fall10+standard\'\n                        });\n    \n                    }\n                '
	                }]
	            },
	            _react2.default.createElement(
	                'title',
	                null,
	                'Have It Made | Style | Clayton Homes'
	            )
	        )
	    );
	};
	
	exports.default = Style;
	module.exports = exports['default'];

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    background-position: center top;\n    color: ', ';\n    display: block;\n    font-family: \'acumin-pro\', sans-serif;\n    \n    width: 100%;\n\n    .header-overlay {\n        background-repeat: no-repeat;\n        left: 0;\n        position: absolute;\n        top: 0;\n        z-index: ', ';\n        width: 100%;\n    }\n\n    .header-overlay-filter {\n        background-color: ', ';\n        height: 100%;\n        width: 100%;\n    }\n\n    @media screen and (', '){\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: auto 100%;\n            height: 265px;\n        }\n\n        display: table;\n\n        .movin-header {\n            margin-top: -2px;\n\n            & > div, & > h3 {\n                display: inline-block;\n                vertical-align: middle;\n            }\n\n            h3 {\n                padding-left: 4px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: table;\n            letter-spacing: -.35px;\n            margin-top: 2px;\n            padding-top: 15px;\n            width: 86%;\n        }\n        \n        .body-column-left {\n            display: table-cell;\n            width: 50%\n        }\n\n         .body-column-right {\n            display: table-cell;\n            padding-left: 25px;\n            width: 50%\n         }\n\n    }\n\n    \n    @media screen and (min-width: 1501px) {\n        .header-overlay {\n            background-size: 100% auto;\n        }\n    }\n\n    @media screen and (', '){\n        display: block;\n\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: auto 100%;\n            height: 265px;\n        }\n\n        .movin-header {\n            display: table;\n            margin-left: -10px;\n            margin-top: -8px;\n\n            & > div, & > h3 {\n                display: table-cell;\n                vertical-align: middle;\n            }\n\n            h3 {\n                padding-left: 10px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: block;\n            letter-spacing: -.30px;\n            margin-left: -3px;\n            margin-top: 16px;\n            padding-top: 24px;\n            width: 99%;\n        }\n        \n        .body-column-left {\n            display: block;\n            width: 100%;\n        }\n\n         .body-column-right {\n            display: block;\n            padding-left: 0;\n            padding-top: 15px;\n            width: 100%;\n         }\n    }\n\n    @media screen and (', '){\n        display: block;\n\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: 100% auto;\n            height: 270px;\n        }\n\n        .movin-header {\n            display: table;\n            margin-left: -10px;\n            margin-top: -12px;\n\n            & > div, & > h3 {\n                display: table-cell;\n                vertical-align: middle;\n            }\n\n            h3 {\n                letter-spacing: -.1px;\n                line-height: 1.4;\n                padding-left: 12px;\n                padding-right: 20px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: block;\n            letter-spacing: -.33px;\n            line-height: 1.7;\n            margin-left: -1px;\n            margin-top: 7px;\n            padding-right: 15px;\n            padding-top: 20px;\n            width: 100%;\n        }\n        \n        .body-column-left {\n            display: block;\n            width: 100%;\n        }\n\n        .body-column-right {\n            display: block;\n            padding-left: 0px;\n            padding-top: 15px;\n            width: 100%;\n         }\n    }\n\n    @media screen and (max-width: 392px) {\n        .header-overlay {\n            background-size: auto 100%;\n        }\n    }\n'], ['\n    background-position: center top;\n    color: ', ';\n    display: block;\n    font-family: \'acumin-pro\', sans-serif;\n    \n    width: 100%;\n\n    .header-overlay {\n        background-repeat: no-repeat;\n        left: 0;\n        position: absolute;\n        top: 0;\n        z-index: ', ';\n        width: 100%;\n    }\n\n    .header-overlay-filter {\n        background-color: ', ';\n        height: 100%;\n        width: 100%;\n    }\n\n    @media screen and (', '){\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: auto 100%;\n            height: 265px;\n        }\n\n        display: table;\n\n        .movin-header {\n            margin-top: -2px;\n\n            & > div, & > h3 {\n                display: inline-block;\n                vertical-align: middle;\n            }\n\n            h3 {\n                padding-left: 4px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: table;\n            letter-spacing: -.35px;\n            margin-top: 2px;\n            padding-top: 15px;\n            width: 86%;\n        }\n        \n        .body-column-left {\n            display: table-cell;\n            width: 50%\n        }\n\n         .body-column-right {\n            display: table-cell;\n            padding-left: 25px;\n            width: 50%\n         }\n\n    }\n\n    \n    @media screen and (min-width: 1501px) {\n        .header-overlay {\n            background-size: 100% auto;\n        }\n    }\n\n    @media screen and (', '){\n        display: block;\n\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: auto 100%;\n            height: 265px;\n        }\n\n        .movin-header {\n            display: table;\n            margin-left: -10px;\n            margin-top: -8px;\n\n            & > div, & > h3 {\n                display: table-cell;\n                vertical-align: middle;\n            }\n\n            h3 {\n                padding-left: 10px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: block;\n            letter-spacing: -.30px;\n            margin-left: -3px;\n            margin-top: 16px;\n            padding-top: 24px;\n            width: 99%;\n        }\n        \n        .body-column-left {\n            display: block;\n            width: 100%;\n        }\n\n         .body-column-right {\n            display: block;\n            padding-left: 0;\n            padding-top: 15px;\n            width: 100%;\n         }\n    }\n\n    @media screen and (', '){\n        display: block;\n\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: 100% auto;\n            height: 270px;\n        }\n\n        .movin-header {\n            display: table;\n            margin-left: -10px;\n            margin-top: -12px;\n\n            & > div, & > h3 {\n                display: table-cell;\n                vertical-align: middle;\n            }\n\n            h3 {\n                letter-spacing: -.1px;\n                line-height: 1.4;\n                padding-left: 12px;\n                padding-right: 20px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: block;\n            letter-spacing: -.33px;\n            line-height: 1.7;\n            margin-left: -1px;\n            margin-top: 7px;\n            padding-right: 15px;\n            padding-top: 20px;\n            width: 100%;\n        }\n        \n        .body-column-left {\n            display: block;\n            width: 100%;\n        }\n\n        .body-column-right {\n            display: block;\n            padding-left: 0px;\n            padding-top: 15px;\n            width: 100%;\n         }\n    }\n\n    @media screen and (max-width: 392px) {\n        .header-overlay {\n            background-size: auto 100%;\n        }\n    }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _LandingPageStyles = __webpack_require__(11);
	
	var _LandingPageStyles2 = _interopRequireDefault(_LandingPageStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SubpageContainer = _styledComponents2.default.div(_templateObject, _colors2.default.grayscaleCoolGray11, _LandingPageStyles2.default.zIndices.headerOverlay, _LandingPageStyles2.default.grayFilter, _LandingPageStyles2.default.viewBreakpoints.desktop, function (props) {
	    return props.backgroundImages.desktopImage;
	}, _LandingPageStyles2.default.viewBreakpoints.tablet, function (props) {
	    return props.backgroundImages.tabletImage;
	}, _LandingPageStyles2.default.viewBreakpoints.mobile, function (props) {
	    return props.backgroundImages.mobileImage;
	});
	
	exports.default = SubpageContainer;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-style-js-44bf3325845b6807eb50.js